if (typeof Swiper === 'undefined') {
  console.error('Swiper library not loaded');
}

class CommunityInstagram extends HTMLElement {
  constructor() {
    super();
    this.swiperInstance = null;
    this.mobileBreakpoint = 749;
    this.dom = {};
  }

  connectedCallback() {
    this.section = this.closest('.community-instagram');
    if (this.section) {
      this.cacheDOM();
      this.initSwiper();
      this.handleResize();
    }
  }

  cacheDOM() {
    this.dom.swiperEl = this.section.querySelector('.community-instagram__swiper');
  }

  initSwiper() {
    if (!this.dom.swiperEl) return;

    // Only init Swiper on mobile
    if (window.innerWidth <= this.mobileBreakpoint) {
      this.createSwiper();
    }
  }

  createSwiper() {
    if (this.swiperInstance || !this.dom.swiperEl) return;

    this.swiperInstance = new Swiper(this.dom.swiperEl, {
      slidesPerView: 'auto',
      spaceBetween: 6,                    // Figma Mobile: section/spacing/gap-column = 6px
      centeredSlides: true,               // Figma Mobile: centered
      loop: true,                         // Infinite loop
    });
  }

  destroySwiper() {
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
      this.swiperInstance = null;
    }
  }

  handleResize() {
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        if (window.innerWidth <= this.mobileBreakpoint) {
          this.createSwiper();
        } else {
          this.destroySwiper();
        }
      }, 250);
    });
  }
}

customElements.define('community-instagram', CommunityInstagram);

function initCommunityInstagram(container = document) {
  const sections = container.querySelectorAll('.community-instagram:not([data-initialized])');

  sections.forEach(section => {
    section.setAttribute('data-initialized', 'true');
    const customElement = document.createElement('community-instagram');
    section.appendChild(customElement);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initCommunityInstagram();
});

document.addEventListener('shopify:section:load', (event) => {
  if (event.target.querySelector('.community-instagram')) {
    initCommunityInstagram(event.target);
  }
});
